import React from 'react';
import DashboardShell from '../../../layouts/DashboardShell';
import PostJobPage from '../../../features/post-job/pages/PostJobPage';
import { clientSideLinks } from '../clientRoutes';

function ClientPostJobPage() {
  return (
    <DashboardShell role="CLIENT" sideLinks={clientSideLinks}>
      <PostJobPage />
    </DashboardShell>
  );
}

export default ClientPostJobPage;